import {Component, HostBinding, Input, OnInit} from "@angular/core";

@Component({
  selector: 'vb-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  @HostBinding('attr.role') roleAtribute = "dialog";
  @HostBinding('attr.tabindex') tabindexAttribute = "-1";
  @HostBinding('attr.aria-labelledby') aria_labelledbyAttribute = "modelLabel";
  @HostBinding('attr.aria-hidden') aria_hiddenAttribute = "true";

  //@HostBinding('config') configProperty = "{backdrop: (isStatic ? 'static' : true), show: true}";

  @HostBinding('class') classAttribute = "modal fade";

  @Input()
  title: string = "";

  @Input()
  isStatic: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/dialogs/modal/modal.component.ts